import { Avatar } from "@material-tailwind/react";

export function AvatarDefault() {
  return (
    <Avatar
      src="https://docs.material-tailwind.com/img/face-2.jpg"
      alt="avatar"
    />
  );
}
